import React, { useEffect, useState } from "react";
import "./style.css";
import {
  getDentalIdPricingTable,
  onSubscribeDentalIdPlan,
} from "../../../components/https/planSubscriptions";
import { errorRequestHandel } from "../../../helper";
import { message, Row, Spin } from "antd";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import ConfirmationModal from "../../ConfirmationModal";
import CustomModal from "../../../age-assessment/components/modals/CustomModal";
import CustomButtonWithIcon from "../../../dentail-indetifcation/components/d-reusable/CustomButtonWithIcon";

const DentalIDPricingTable = ({ onClose, onRefetch, seats }) => {
  const [activeTab, setActiveTab] = useState("month");
  const [loading, setLoading] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [plans, setPlans] = useState({ month: [], year: [] });
  const [noOfSeats, setNoOfSeats] = useState(seats);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    getPricingTableData();
  }, []);

  const getPricingTableData = async () => {
    try {
      setLoading(true);
      const response = await getDentalIdPricingTable();
      if (response.status === 200) {
        const data = response?.data?.data || [];

        // Group by interval (month/year)
        const grouped = { month: [], year: [] };
        data.forEach((plan) => {
          const interval = plan.recurring?.interval;
          if (interval === "month") grouped.month.push(plan);
          if (interval === "year") grouped.year.push(plan);
        });

        // Add Enterprise package manually
        const enterprisePlan = {
          id: "enterprise",
          nickname: "Dental ID Enterprise",
          description:
            "A custom solution designed for teams and organizations needing full platform access, powerful AI tools, and personalized support. Includes on-premise setup, unlimited projects, 300 AI credits, and dedicated onboarding, perfect for high-volume or security-sensitive environments.",
          unit_amount: null,
          recurring: { interval: "custom" },
        };

        grouped.month.push(enterprisePlan);
        grouped.year.push(enterprisePlan);

        setPlans(grouped);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      onClose();
      errorRequestHandel({ error });
    }
  };

  const formatAmount = (amountInCents) => `${(amountInCents / 100).toFixed(2)}`;

  const handleOnContactUs = () => {
    const url = "https://dentalid.app/contact-us.html";
    window.open(url, "_blank"); // open in new tab
  };

  const onHandleSubscribeNow = async (id) => {
    try {
      const payload = {
        price_id: id,
        no_of_seats: noOfSeats,
      };

      setIsLoading(true);

      const response = await onSubscribeDentalIdPlan({ payload: payload });
      if (response.status === 200) {
        setShowConfirmationModal(true);
        onRefetch();
        setIsLoading(false);
        onClose();
      }
    } catch (error) {
      setIsLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const increaseSeats = () => {
    setNoOfSeats((prev) => prev + 1);
  };

  const decreaseSeats = () => {
    setNoOfSeats((prev) => prev - 1);
  };

  if (loading) {
    return (
      <div className="prcing_table_loading">
        <Spin size="large" />
      </div>
    );
  }

  if (!plans.month.length && !plans.year.length) {
    return ""; // No plans
  }

  return (
    <div className="update_plan_container">
      <div className="update_plan_body">
        {/* Tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 16,
          }}
        >
          {plans.month.length > 0 && (
            <button
              style={{
                padding: "8px 24px", // py-2 px-6
                borderRadius: "12px 0 0 12px", // rounded-l-xl
                border: "1px solid #d1d5db", // border (default gray-300)
                backgroundColor: activeTab === "month" ? "#20C3FF" : "#fff",
                color: activeTab === "month" ? "#fff" : "#4b5563", // gray-600
              }}
              onClick={() => setActiveTab("month")}
            >
              Monthly
            </button>
          )}

          {plans.year.length > 0 && (
            <button
              style={{
                padding: "8px 24px", // py-2 px-6
                borderRadius: "0 12px 12px 0", // rounded-r-xl
                border: "1px solid #d1d5db", // border (gray-300)
                backgroundColor: activeTab === "year" ? "#20C3FF" : "#fff",
                color: activeTab === "year" ? "#fff" : "#4b5563", // gray-600
              }}
              onClick={() => setActiveTab("year")}
            >
              Yearly
            </button>
          )}
        </div>

        <div className="upgrade_plans_section">
          {plans[activeTab]?.map((plan) => (
            <div key={plan.id} className="plan_card">
              <div style={{ flex: 1 }}>
                <h3>{plan.nickname || "Dental ID"}</h3>

                {plan.id === "enterprise" ? (
                  // <p className="plan_description">{plan.description}</p>
                  <>
                    <p style={{ marginTop: "8px" }}>
                      A tailored solution for teams that require advanced
                      capabilities and full platform access.
                      <strong> Dental ID Enterprise includes:</strong>
                    </p>

                    <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
                      <li style={{ fontSize: "12px" }}>
                        On-premise deployment
                      </li>
                      <li style={{ fontSize: "12px" }}>Unlimited projects</li>
                      <li style={{ fontSize: "12px" }}>300 AI credits</li>
                      <li style={{ fontSize: "12px" }}>
                        Dedicated onboarding and support
                      </li>
                    </ul>

                    <p style={{ marginTop: "8px" }}>
                      Perfect for high-volume use cases or security-sensitive
                      environments.
                    </p>
                  </>
                ) : (
                  <>
                    <div className="plan_left_current">
                      <h1>${formatAmount(plan.unit_amount)}</h1>
                      <div className="plan_interval">
                        <p className="">
                          Per Seat /{" "}
                          {plan.recurring?.interval === "month"
                            ? "Month"
                            : "Year"}
                        </p>
                        {/* <p className="per_amount">
                          {plan.recurring?.interval === "month"
                            ? "Month"
                            : "Year"}
                        </p> */}
                      </div>
                    </div>
                    <div className="info_item">
                      <p>
                        Your total today:{" "}
                        <strong>
                          ${formatAmount(plan.unit_amount * noOfSeats)}
                        </strong>{" "}
                        for {noOfSeats} seat
                        {noOfSeats > 1 ? "s" : ""}
                      </p>
                      <br />
                      <p>
                        Designed for organizations of any size, Dental ID
                        provides powerful AI tools and secure access for your
                        team. Add seats as needed and scale effortlessly as your
                        organization grows.
                      </p>
                    </div>
                    <br />
                    <Row
                      gutter={[10, 10]}
                      style={{ gap: 10, margin: "20px 0" }}
                      justify={"center"}
                    >
                      <CustomButtonWithIcon
                        title="-"
                        onClick={decreaseSeats}
                        width={100}
                        fontSize={30}
                        disabled={noOfSeats === 1}
                      />
                      <p
                        className="_seats"
                        style={{
                          marginTop: 10,
                          fontSize: 20,
                          padding: "0 30px",
                          fontWeight: "bold",
                        }}
                      >
                        {noOfSeats}
                      </p>
                      <CustomButtonWithIcon
                        title="+"
                        onClick={increaseSeats}
                        width={100}
                        fontSize={30}
                      />
                    </Row>
                    <br />
                  </>
                )}
              </div>

              <div className="plan_button_wrapper">
                <CustomPrimaryButton
                  isLoading={plan.id === "enterprise" ? false : isloading}
                  title={
                    plan.id === "enterprise" ? "Contact Us" : "Subscribe Now"
                  }
                  width={"80%"}
                  onClick={() => {
                    if (plan.id === "enterprise") {
                      handleOnContactUs();
                    } else {
                      onHandleSubscribeNow(plan?.id);
                    }
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
      <CustomModal
        open={showConfirmationModal}
        width={"50%"}
        onCancel={() => setShowConfirmationModal(false)}
      >
        <ConfirmationModal onCancel={() => setShowConfirmationModal(false)} />
      </CustomModal>
    </div>
  );
};

export default DentalIDPricingTable;
